import type { FlowHighlight } from './flowFocus'
import { type FlowValueFormat, formatFlowAmount } from './flowFormat'
import type { FlowLabel } from './flowLayout'

const DIM_OPACITY = 0.25
const NAME_BASELINE_OFFSET = -1
const AMOUNT_LINE_GAP = 14
const HALO_WIDTH = 4

// Labels wear ink, never the flow colors. A halo in the surface color
// keeps text readable where it sits over links.
export function FlowLabels({
  labels,
  highlight,
  valueFormat,
}: {
  labels: FlowLabel[]
  highlight: FlowHighlight | null
  valueFormat: FlowValueFormat
}) {
  return (
    <g
      className="pointer-events-none select-none"
      stroke="hsl(var(--card))"
      strokeWidth={HALO_WIDTH}
      strokeLinejoin="round"
      paintOrder="stroke"
    >
      {labels.map((label) => (
        <text
          key={label.name}
          x={label.x}
          y={label.y + NAME_BASELINE_OFFSET}
          textAnchor={label.side === 'left' ? 'end' : 'start'}
          opacity={
            highlight && !highlight.nodes.has(label.name) ? DIM_OPACITY : 1
          }
          className="transition-opacity duration-150"
        >
          <tspan fontSize={12} fontWeight={500} className="fill-foreground">
            {label.text}
          </tspan>
          <tspan
            x={label.x}
            dy={AMOUNT_LINE_GAP}
            fontSize={11}
            className="fill-muted-foreground"
          >
            {formatFlowAmount(label.amount, valueFormat)}
          </tspan>
        </text>
      ))}
    </g>
  )
}
